import CtaButtonGroup, { CtaType } from '@/components/molecules/CtaButtonGroup';
import Image from 'next/image';
import React from 'react';

interface IntentCardProps {
  icon: string;
  title: string;
  description: string;
}

interface WebinarIntentProps {
  subTitle:string;
  ctas: CtaType[];
  WebinarIntentDetails : IntentCardProps[],
  title:string;
}

const IntentCard: React.FC<IntentCardProps> = ({ icon, title, description }) => (
  <div className="rounded-lg flex flex-col items-center bg-paleYellow">
    
    <div className="flex items-center justify-center h-[200px]">
      <Image src={icon} alt={title} width={300} height={300} />
    </div>
   
    
    <div className="bg-grey-2 p-6 rounded-b-lg flex flex-col items-center justify-center h-[180px] ">
    <h3 className="text-lg font-semibold mb-2">{title}</h3>
    <p className="text-sm text-gray-600">{description}</p>
    </div>
  </div>
);

const WebinarIntent: React.FC<WebinarIntentProps> = ({subTitle,ctas, WebinarIntentDetails, title}) => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <h2 className="text-3xl font-bold text-center mb-12">{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {WebinarIntentDetails && WebinarIntentDetails.map((item, index) => (
          <IntentCard
            key={index}
            icon={item.icon}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
      <div className="mt-12 text-center">
        <p className="mb-4">{subTitle}</p>
        <CtaButtonGroup align="sm:center" ctas={ctas} affiliateButton={true} />
      </div>
    </div>
  );
};

export default WebinarIntent;